import { reactLocalStorage } from "reactjs-localstorage"

function isSuperAdmin() {
    let getUserInfo = reactLocalStorage.get('user_info')
    getUserInfo = getUserInfo ? JSON.parse(getUserInfo) : null
    if (getUserInfo.role == "superadmin") { return true}
    return false
}

export { isSuperAdmin }